<template>
  <div>
    <div class="selectPlan">
      <div class="switchQuote">
        <div class="switchQuote__container">
          <input type="radio" id="phone" value="tpl" v-model.lazy="switchValue_" >
          <label for="phone">{{ $t('renew_change_policy_tpl') }} <div class="selectPlan__discount-badge"> {{$t('renew_change_policy_online')}} </div></label>
        </div>
        <div class="switchQuote__container">
          <input type="radio" id="policy" value="comp" v-model.lazy="switchValue_">
          <label for="policy">{{ $t('renew_change_policy_comp') }} </label>
        </div>
      </div>
      <div class="selectPlan__customize">
        <template v-if="switchValue_ ==='tpl'">
          <ul class="selectPlan__customize-list" >
            <li class="included">{{$t('renew_car_change_plan_tpl')}}</li>
            <li class="included">{{$t('renew_car_change_plan_passenger')}}</li>
            <li class="not-included">{{$t('renew_car_change_plan_damage')}}</li>
            <li class="not-included">{{$t('renew_car_change_plan_roadside')}}</li>
            <li class="not-included">{{$t('renew_car_change_plan_repairs')}}</li>
            <li class="not-included">{{$t('renew_car_change_plan_deprecation')}}</li>
            <li class="not-included">{{$t('renew_car_change_plan_benefit')}}</li>
            <li class="not-included">{{$t('renew_car_change_plan_offroad')}}</li>
          </ul>
        </template>
        <template v-else>
          <p class="selectPlan__upgrade-desc"> {{$t('renew_change_policy_no_od_warn_1')}} (<span class="selectPlan__upgrade-desc-product">{{productTitle}}</span>) {{$t('renew_change_policy_no_od_warn_2')}}</p>
          <ul class="selectPlan__customize-list">
            <li class="included">{{$t('renew_car_change_plan_tpl')}}</li>
            <li class="included">{{$t('renew_car_change_plan_passenger')}}</li>
            <li class="included">{{$t('renew_car_change_plan_damage')}}</li>
            <li class="included">{{$t('renew_car_change_plan_roadside')}}</li>
            <li class="included">{{$t('renew_car_change_plan_repairs')}}</li>
            <li class="included">{{$t('renew_car_change_plan_deprecation')}}</li>
            <li class="included">{{$t('renew_car_change_plan_benefit')}}</li>
            <li class="included">{{$t('renew_car_change_plan_offroad')}}</li>
          </ul>
        </template>
        <div v-if="switchValue_==='tpl'" class="selectPlan__from">{{ $t('renew_qar', { price: this.$options.filters.splitNumber(priceFromForTplPlan) }) }} </div>
      </div>
    </div>
    <BaseButton
      v-if="switchValue_ === 'comp'"
      symbol="no"
      @click.prevent="contactsPopup = true">
      {{ $t('renew_contacts') }}
    </BaseButton>
    <BaseButton v-else @click.prevent="$emit('submit')"/>
    <ContactsPopup v-model="contactsPopup" @close="contactsPopup = false"/>
  </div>
</template>

<script>
import ContactsPopup from '@/components/ContactsPopup'
export default {
  name: 'MotorChangeNoOdSchemesForm',
  props: {
    switchValue: { type: String, default: 'comp' },
    priceFromForTplPlan: {},
    productTitle: { type: String, defalult: '' }
  },
  components: {
    ContactsPopup
  },
  data () {
    return {
      switchValue_: this.switchValue,
      contactsPopup: false
    }
  }
}
</script>

<style scoped lang="scss">
.selectPlan__upgrade-desc-product {
  font-weight: 600;
}
</style>
